module.exports = __webpack_public_path__ + "static/media/SVG_menu_home.dc45c36d.svg";